/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Start_Delivery_TitleInputs */

const vi_trip_start_delivery_title = /** @type {(inputs: Trip_Start_Delivery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu giao hàng`)
};

/**

* @param {Trip_Start_Delivery_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_start_delivery_title = /** @type {((inputs?: Trip_Start_Delivery_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Start_Delivery_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_start_delivery_title(inputs)
});